// const LOCALE_GERMAN = 'de'
// const LOCALE_ENGLISH = 'en'
const LOCALE_ITALIAN = 'it';
// const LOCALE_FRENCH = 'fr'
// const LOCALE_POLISH = 'pl'
// const LOCALE_DANISH = 'dk'
// const LOCALE_SLOVENIAN = 'si'
// const LOCALE_CZECH = 'cz'
const DEFAULT_LOCALE = LOCALE_ITALIAN;

const SUPPORTED_LOCALES = [
  // [LOCALE_ENGLISH, 'English'],
  // [LOCALE_GERMAN, 'Deutsch'],
  [LOCALE_ITALIAN, 'Italiano'],
  // [LOCALE_FRENCH, 'Français'],
  // [LOCALE_DANISH, 'Dansk'],
  // [LOCALE_SLOVENIAN, 'Slovenščina'],
  // [LOCALE_CZECH, 'Čeština'],
  // [LOCALE_POLISH, 'Polski'],
];

module.exports = {
  // Meta
  EMAIL: 'info@itamat.it',
  // Analytics
  GA_KEY: 'test',
  GA_COOKIE_NAME: '_itamat-ga',
  // API
  // Languages
  // LOCALE_GERMAN,
  // LOCALE_ENGLISH,
  LOCALE_ITALIAN,
  // LOCALE_FRENCH,
  // LOCALE_POLISH,
  // LOCALE_DANISH,
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
};
